import { NumericInput } from '@/src/components'
import type { InputProps } from '@chakra-ui/react'
import type { ReactNode } from 'react'

interface IFormInput {
  name: string
  label?: string
  disabled?: boolean
  width?: string | number
  decimals?: number
  labelRight?: string
  labelRightOptions?: readonly string[]
  onLabelRightChange?: (value: string) => void
  textAlign?: string
  isRequired?: boolean
  infoTooltip?: string
  labelFontSize?: string
  labelFontColor?: string
  prependComponent?: ReactNode
  onChange?: (value: string, name: string, values: { float: number | null; formatted: string; value: string }) => void
  formControlWidth?: string
  componentStyle?: React.CSSProperties
}

type FormInput = Omit<InputProps, 'onChange'> & IFormInput

export const FormNumericInput = ({
  name,
  label,
  value,
  width,
  disabled,
  onChange,
  decimals,
  labelRight,
  labelRightOptions,
  onLabelRightChange,
  textAlign,
  infoTooltip,
  isRequired,
  labelFontSize,
  labelFontColor,
  prependComponent,
  formControlWidth,
  componentStyle,
  ...props
}: FormInput) => {
  return (
    <NumericInput
      name={name}
      value={value}
      label={label ?? ''}
      labelRight={labelRight}
      labelRightOptions={labelRightOptions}
      onLabelRightChange={onLabelRightChange}
      labelFontSize={labelFontSize ?? '12px'}
      labelFontColor={labelFontColor ?? 'gray.600'}
      width={width}
      textAlign={textAlign}
      newStyle
      disabled={disabled}
      isRequired={isRequired}
      blackInfoIcon={true}
      showInfo={!!infoTooltip}
      helperText={infoTooltip}
      decimalsLimit={decimals ?? 2}
      prependComponent={prependComponent}
      formControlWidth={formControlWidth}
      componentStyle={componentStyle}
      onValueChange={(value, name, values) => {
        if (values.formatted === 'NaN') return
        return onChange?.(value, name, values)
      }}
      {...props}
    />
  )
}
